import apiClient from "../client";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const getCategories = async () => {
  try {
    const res = await apiClient.get(`${API_BASE_URL}/intron/job/categories`);
    return res?.data?.data?.items || [];
  } catch (error) {
    console.error("Error fetching categories:", error);
    return [];
  }
};
